import FeatureToggleUtils from 'FeatureToggleUtils';
import { isRingAvailableSelector } from '../selectors/RingSelectors';
import { getUserSessions, getSessions, getSessionsUserMap, getSessionsMap } from '../views/reactViews/ApiUtil';

export const fetchSessionsFromApi = (state) => {
    const isSessionVisibilityEnabled = FeatureToggleUtils.isFeatureEnabled('session-visibility');
    const isRingAvailable = isRingAvailableSelector(state);
    const shouldWorkVenueOnlyBehavior = isRingAvailable && isSessionVisibilityEnabled;
    const shouldAlignVenueAndAgendaBehavior = FeatureToggleUtils.isFeatureEnabled('session-visibility') && FeatureToggleUtils.isFeatureEnabled('agenda-venue-behavior-alignment');
    const fetchSessions = (shouldWorkVenueOnlyBehavior || shouldAlignVenueAndAgendaBehavior) ? getUserSessions : getSessions;
    return fetchSessions;
};

export const fetchSessionsMapFromApi = (state) => {
    const isSessionVisibilityEnabled = FeatureToggleUtils.isFeatureEnabled('session-visibility');
    const isRingAvailable = isRingAvailableSelector(state);
    const shouldWorkVenueOnlyBehavior = isRingAvailable && isSessionVisibilityEnabled;
    const shouldAlignVenueAndAgendaBehavior = FeatureToggleUtils.isFeatureEnabled('session-visibility') && FeatureToggleUtils.isFeatureEnabled('agenda-venue-behavior-alignment');
    const fetchSessionsMap = (shouldWorkVenueOnlyBehavior || shouldAlignVenueAndAgendaBehavior) ? getSessionsUserMap : getSessionsMap;
    return fetchSessionsMap;
};
